const PANELS = {
    ProcessVariants(vm) {
        const ctx = vm

        return {
            component: 'ProcessVariantsDrawerPanel',
            title: ctx.$t('visualization.variants'),
            icon: 'alt_route',
            props: {
                modelValue: ctx.drawerModel,
                processId: ctx.processId,
                info: ctx.infoTotal || { cases: 0, variants: 1 },
                filteredInfo: ctx.infoFiltered || { cases: 0, variants: 1 },
                percentageMode: 'TOTAL',
                disableElements: ctx.disableComponents || ctx.drawerBusy,
                showLoopsSection: false,
            },
            on: {
                'on-center-chart': () => ctx.callActiveView('handleCenterChart'),
                'on-request-model-info': (payload) => ctx.callActiveView('handleRequestModelInfo', payload),
                'on-load-chart': (payload) => ctx.callActiveView('handleSetChart', payload),
                'on-color-loops': (payload) => ctx.callActiveView('handleColorChartLoops', payload),
                'on-reset': () => ctx.callActiveView('handleResetModel'),
                'variants-loading': (load) => {
                    ctx.drawerBusy = !!load
                    ctx.callActiveView('loadingControl', load)
                },
                'on-changed-variant': () => ctx.callActiveView('handleChangedVariant'),
                'on-changed-variant-tab': (tab) => ctx.callActiveView('handleChangeVariantTab', tab),
                'on-open-rename-modal': ({ variantId }) => ctx.handleOpenRenameVariantModal(variantId),
            },
        }
    },
    ProcessRework(vm) {
        const ctx = vm
        return {
            component: 'ProcessLoopsDrawerPanel',
            title: ctx.$t('visualization.loops'),
            icon: '360',
            props: {
                value: ctx.drawerModel,
                processId: ctx.processId,
                info: ctx.infoTotal || { cases: 0, variants: 1 },
                percentageMode: 'TOTAL',
                disableElements: ctx.disableComponents || ctx.drawerBusy,
            },
            on: {
                'on-center-chart': () => ctx.callActiveView('handleCenterChart'),
                'on-request-model-info': (payload) => ctx.callActiveView('handleRequestModelInfo', payload),
                'on-load-chart': (payload) => ctx.callActiveView('handleSetChart', payload),
                'on-reset': () => ctx.callActiveView('handleResetModel'),
                'variants-loading': (load) => {
                    ctx.drawerBusy = !!load
                    ctx.callActiveView('loadingControl', load)
                },
                'on-open-rename-loop-modal': ({ loopId }) => ctx.handleOpenRenameLoopModal(loopId),
            },
        }
    },

    ProcessConformance(vm) {
        const ctx = vm
        return {
            component: 'ProcessConformanceDrawerPanel',
            title: ctx.$t('visualization.tabs.conformance'),
            icon: 'fact_check',
            props: {
                projectId: ctx.$route?.params?.projectId,
                processId: ctx.processId,
                filteredTraces: ctx.infoFiltered?.cases || 0,
                disableElements: ctx.disableComponents || ctx.drawerBusy,
                modelId: ctx.conformanceModelId,
            },
            on: {
                'on-model-selected': (payload) => ctx.handleConformanceModelSelected(payload),
                'on-preview-model': (payload) => ctx.handleConformanceModelPreview(payload),
                'on-models-loaded': (payload) => ctx.handleConformanceModelsLoaded(payload),
            },
        }
    },

    ProcessTraces(vm) {
        const ctx = vm
        return {
            component: 'ProcessTracesDrawerPanel',
            title: ctx.$t('visualization.tabs.traces'),
            icon: 'list',
            props: {
                filteredTraces: ctx.infoFiltered?.cases || 0,
                disableElements: ctx.disableComponents || ctx.drawerBusy,
                search: ctx.tracesDrawerSearch || '',
            },
            on: {
                'update:search': (value) => { ctx.tracesDrawerSearch = value },
                'on-search': (payload) => ctx.callActiveView('applyTracesSearch', payload),
                'on-export': () => ctx.callActiveView('openTracesExport'),
                'on-create-dataset': (payload) => ctx.callActiveView('createTracesDataset', payload),
            },
        }
    },

    ProcessDashboards(vm) {
        const ctx = vm
        return {
            component: 'ProcessDashboardsDrawerPanel',
            title: ctx.$t('process.dashboards'),
            icon: 'dashboard',
            props: {
                editMode: ctx.dashboardsDrawer?.editMode,
                graphObj: ctx.dashboardsDrawer?.graphObj,
                sideTab: ctx.dashboardsDrawer?.sideTab,
                layoutData: ctx.dashboardsDrawer?.layoutData,
                dashboardFilters: ctx.dashboardsDrawer?.dashboardFilters,
                allFilters: ctx.dashboardsDrawer?.allFilters,
                attributes: ctx.dashboardsDrawer?.attributes,
                categoricalAttributes: ctx.dashboardsDrawer?.categoricalAttributes,
                numericAttributes: ctx.dashboardsDrawer?.numericAttributes,
            },
            on: {
                'on-enter-edit': () => ctx.callActiveView('dashboardsEnterEditMode'),
                'on-save-edit': () => ctx.callActiveView('dashboardsSaveEditMode'),
                'on-cancel-edit': () => ctx.callActiveView('dashboardsCancelEditMode'),
                'on-set-side-tab': (tab) => ctx.callActiveView('dashboardsSetSideTab', tab),
                'on-add-graph': ({ type, group } = {}) => ctx.callActiveView('dashboardsAddGraph', { type, group }),
                'on-update-triggers': ({ triggers } = {}) => ctx.callActiveView('dashboardsUpdateTriggers', { triggers }),
                'on-update-graph': (payload) => ctx.callActiveView('dashboardsUpdateGraph', payload),
                'on-rename-graph': ({ name } = {}) => ctx.callActiveView('dashboardsRenameGraph', { name }),
            },
        }
    },
}

export const processContextDrawerRoutes = Object.freeze(Object.keys(PANELS))

export function getProcessContextDrawerPanel(vm) {
    const factory = PANELS[vm.routeName]
    if (!factory) {
        return {
            component: null,
            props: {},
            on: {},
            title: '',
            icon: 'tune',
        }
    }
    return factory(vm)
}
